export default "__VITE_ASSET__C7bq9WB4__"